module.exports = "//static.hsappstatic.net/conversations-embed/static-1.24524/sass/messagesWidgetShell.sass"